import styled from 'styled-components';
import {
  TextField, Text, Box,
} from '@usealloy/component-library';
import { Link } from 'react-router-dom';

export const StyledTextField = styled(TextField)`
  &&& {
    height: var(--cl-space-10);
    line-height: var(--cl-line-height-2);
  }
`;

export const ValidationTextField = styled(Text)`
  &&& {
    color: var(--cl-gray-700);
    font-size: var(--cl-font-size-1);
    line-height: var(--cl-line-height-2);
    text-transform: capitalize;
  }
`;

export const RestoreLink = styled.a`
  display: block;
  font-size: var(--cl-font-size-1);
  line-height: var(--cl-line-height-2);
  text-transform: capitalize;
  font-weight: normal;
`;

export const StyledBox = styled(Box)`
  &&& {
    direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;

export const LabelText = styled(Text)`
  &&& {
    color: var(--cl-gray-700);
    font-size: var(--cl-font-size-1);
    line-height: var(--cl-line-height-2);
  }
`;

export const StyledLink = styled.a`
  color: var(--cl-juicyBlue-600);
  font-size: var(--cl-font-size-2);
  font-weight: normal;
  text-transform: initial;
  line-height: 24px;
  margin: 0px;
`;

export const StyledValidationLink = styled(Link)`
  &&& {
    color: var(--cl-gray-000);
    font-size: var(--cl-font-size-1);
    font-weight: normal;
    text-transform: initial;
    text-decoration: underline;
  }
`;
